import { render, staticRenderFns } from "./add_complaint.vue?vue&type=template&id=08b102f6&scoped=true"
import script from "./add_complaint.vue?vue&type=script&lang=js"
export * from "./add_complaint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b102f6",
  null
  
)

export default component.exports